import { createContext } from 'react';
import type { ScreenMode, Theming } from './const';

export const ThemeContext = createContext<
  | {
      theme: NonNullable<Theming['theme']>;
      screenMode: ScreenMode;
      setTheme: (theme: NonNullable<Theming['theme']>) => void;
      setScreenMode: (screenMode: ScreenMode) => void;
    }
  | undefined
>(undefined);
